import React, { useState, useEffect } from 'react';
import Icon from '../../components/Icon';

function FounderCard({ member }) {
  const {
    display_name, original_team_name, oneliner,
    seasons_played, championships, isCommissioner,
    founding_year,
  } = member;

  return (
    <div className="lor-founder-card lor-card">
      <div className="lor-founder-badge"><Icon emoji="🏛️" size={14} style={{ verticalAlign: 'middle', marginRight: 4 }} /> Founding Member</div>

      <div className="lor-founder-name">{display_name}</div>

      {original_team_name && (
        <div className="lor-founder-orig-team">
          est. {original_team_name} {founding_year || '2012'}
        </div>
      )}

      {oneliner && (
        <div className="lor-founder-oneliner">{oneliner}</div>
      )}

      <div className="lor-founder-stats">
        {seasons_played != null && (
          <div className="lor-founder-stat">
            <div className="lor-founder-stat-val">{seasons_played}</div>
            <div className="lor-founder-stat-label">Seasons</div>
          </div>
        )}
        {championships != null && (
          <div className="lor-founder-stat">
            <div className="lor-founder-stat-val lor-gold">
              {championships > 0 ? <><Icon emoji="🏆" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> {championships}×</> : '—'}
            </div>
            <div className="lor-founder-stat-label">Championships</div>
          </div>
        )}
      </div>

      {isCommissioner && (
        <div className="lor-founder-comm-badge"><Icon emoji="👑" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> Commissioner</div>
      )}
    </div>
  );
}

function RecognitionCard({ card }) {
  if (!card) return null;
  const {
    display_name, narrative, championships,
    the_trade_note, badge_label,
  } = card;

  return (
    <div className="lor-recognition-card lor-card">
      <div className="lor-recognition-badge">
        {badge_label || '💡 Platform Architect'}
      </div>
      <div className="lor-recognition-name">{display_name}</div>
      {championships != null && (
        <div className="lor-recognition-champs">
          <span className="lor-gold"><Icon emoji="🏆" size={13} style={{ verticalAlign: 'middle', marginRight: 3 }} /> {championships}×</span> Championships
        </div>
      )}
      {narrative && (
        <p className="lor-recognition-narrative">{narrative}</p>
      )}
      {the_trade_note && (
        <div className="lor-recognition-trade-note">
          <span className="lor-recognition-trade-label"><Icon emoji="⚡" size={12} style={{ verticalAlign: 'middle', marginRight: 3 }} /> The Trade</span> {the_trade_note}
        </div>
      )}
    </div>
  );
}

export default function LORFoundingMembers({ api }) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  useEffect(() => {
    fetch(`${api}/api/lor/lore/founding-members`)
      .then(r => { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(d => { setData(d); setLoading(false); })
      .catch(() => { setError('Founding Members data unavailable.'); setLoading(false); });
  }, [api]);

  if (loading) return <div className="lor-loading">Loading Founding Members…</div>;
  if (error)   return <div className="lor-empty">{error}</div>;

  const founding_members   = data?.founding_members || [];
  const recognition_card   = data?.recognition_card || null;
  const subtitle           = data?.subtitle || 'The original five. Still here since 2012.';

  return (
    <div className="lor-founders-page">
      <div className="lor-founders-header lor-page-header">
        <h2 className="lor-page-title" style={{ display: 'flex', alignItems: 'center', gap: 6 }}><Icon emoji="🏛️" size={18} /> Founding Members</h2>
        <div className="lor-page-meta">{subtitle}</div>
      </div>

      <div className="lor-founders-grid">
        {founding_members.length === 0 && (
          <div className="lor-empty">No founding member data available yet.</div>
        )}
        {founding_members.map((m, i) => (
          <FounderCard key={m.display_name || i} member={m} />
        ))}
      </div>

      {recognition_card && (
        <div style={{ marginTop: 28 }}>
          <div className="lor-founders-recognition-label">Special Recognition</div>
          <RecognitionCard card={recognition_card} />
        </div>
      )}
    </div>
  );
}
